import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MKTypography from "components/MKTypography";

import logoCT from "assets/images/logo.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Ramlis Machine",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/ramlis_machine/",
    },
    {
      icon: <WhatsAppIcon />,
      link: "http://wa.me/5511998859120?text=Olá,%20encontrei%20vocês%20pelo%20site%20e%20quero%20mais%20informações.",
    },
  ],
  menus: [
    {
      name: "Navegação",
      items: [
        { name: "Institucional", href: "/institucional" },
        { name: "Estrutura Industrial", href: "/estrutura-industrial" },
        { name: "Produtos e Serviços", href: "/usinagem-precisao" },
        { name: "Qualidade", href: "/qualidade" },
       
      ],
    },
      { name: "Serviços",
      items: [
        { name: "Usinagem CNC", href: "/usinagem-precisao" },
        { name: "Fabricação de Moldes", href: "/usinagem-precisao" },
        { name: "Manutenção Industrial", href: "/usinagem-precisao" },
        { name: "Projetos Especiais", href: "/usinagem-precisao" },
      ],
    },
    {
      name: "Contato",
      items: [
        { name: "R. Tartaruga, 107 - Condomínio Villa Verde, Bragança Paulista/SP", href: "/contato" },
        { name: "+55 11 9 9885-9120", href: "tel:+5511998859120" },
        { name: "contato@ramlismachine.com.br", href: "mailto:contato@ramlismachine.com.br" },
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Todos os direitos reservados. &copy; {date} Ramlis Machine.
    </MKTypography>
  ),
};
